var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaveTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M633.592 262.745L489.593 455.054C483.561 463.129 474.077 467.887 463.999 467.887S444.437 463.129 438.405 455.054L176.001 104.648L57.595 262.745C47.017 276.955 26.986 279.804 12.799 269.162C-1.342 258.551 -4.201 238.456 6.408 224.309L150.407 32C162.47 15.849 189.532 15.849 201.595 32L463.999 382.406L582.405 224.309C592.998 210.13 613.029 207.312 627.201 217.892C641.342 228.503 644.201 248.598 633.592 262.745Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveTriangle);
export default __webpack_public_path__ + "static/media/wave-triangle.9efc1ccbf2134aa131eeacfb70fdafd0.svg";
export { ForwardRef as ReactComponent };